// src/pages/AboutUsPage.tsx
import React from 'react';

const AboutUsPage = () => {
  return (
    <div className="page-container">
      <h2 className="page-title">About Us</h2>
      <p className="page-description">
        Best HVAC Supplies is a leading provider of heating, ventilation, and air conditioning
        equipment and parts. We are committed to providing our customers with high-quality products,
        competitive prices, and exceptional customer service.
      </p>
      <section className="about-section">
        <h3 className="section-subtitle">Our Mission</h3>
        <p className="section-text">
          To be the most trusted and reliable supplier in the HVAC industry, providing our customers
          with the best products and solutions for their needs.
        </p>
      </section>
      <section className="about-section">
        <h3 className="section-subtitle">Our Values</h3>
        <ul className="values-list">
          <li>Quality: We offer only the highest quality products from trusted manufacturers.</li>
          <li>Service: We are dedicated to providing exceptional customer service and support.</li>
          <li>Integrity: We operate with honesty and transparency in all our business dealings.</li>
          <li>Innovation: We continuously seek new and better ways to serve our customers.</li>
        </ul>
      </section>
      <section className="about-section">
        <h3 className="section-subtitle">Our Team</h3>
        <p className="section-text">
          Our team consists of experienced professionals with extensive knowledge of the HVAC industry.
          We are here to help you find the right products for your specific needs.
        </p>
      </section>
    </div>
  );
};

export default AboutUsPage;
